import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import {
  Box,
  Button,
  Divider,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { guestApi } from "../../api/config";
import {
  ref,
  query,
  orderByKey,
  limitToLast,
  get,
  endBefore,
  update,
} from "firebase/database";

import { firebaseRDB } from "../../firebase";
import { useSelector } from "react-redux";
import moment from "moment";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import GradientCirlularProgress from "../../component/Common/GradientCirlularProgress";
import { useNotificationContext } from "../../context/notificationContext";

const TransporterNotificationPage = () => {
  const pageSize = 8;
  const navigate = useNavigate();
  const transporterId = useSelector((state) => state.transporterId.id);

  const [notificationList, setNotificationsList] = useState([]);
  const [lastKey, setLastKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const [isLoading, setisLoading] = useState(false);
  const [error, seterror] = useState(false);

  const notificationRef = ref(firebaseRDB, `history/generic/${transporterId}`);
  const { unreadCount } = useNotificationContext();

  useEffect(() => {
    if (!transporterId) return; // Guard: don't run if transporterId is not set

    const getNotifications = async () => {
      setisLoading(true);
      const notificationQuery = query(
        notificationRef,
        orderByKey(),
        limitToLast(pageSize)
      );

      const snapshot = await get(notificationQuery);
      if (snapshot.exists()) {
        const items = [];
        snapshot.forEach((childSnapshot) => {
          items.push({
            ...childSnapshot.val(),
            key: childSnapshot.key,
          });
        });
        setNotificationsList(items.reverse());

        if (items.length > 0) {
          setLastKey(items[items.length - 1].key);
        }

        if (items.length < pageSize) {
          setHasMore(false);
        }

        setisLoading(false);

        console.log("NOTIFICATIONS:::", items);
      } else {
        setHasMore(false);
        setisLoading(false);
      }
    };

    getNotifications();

    return () => {
      setHasMore(true);
      setLastKey(null);
    };
  }, [transporterId]);

  const fetchNextPage = async () => {
    if (!lastKey) return;

    try {
      const snapshot = await get(
        query(
          notificationRef,
          orderByKey(),
          endBefore(lastKey),
          limitToLast(pageSize)
        )
      );

      if (snapshot.exists()) {
        const items = [];
        snapshot.forEach((childSnapshot) => {
          items.push({
            key: childSnapshot.key,
            ...childSnapshot.val(),
          });
        });
        setNotificationsList((prev) => [...prev, ...items.reverse()]);

        if (items.length > 0) {
          setLastKey(items[items.length - 1].key);
        }

        if (items.length < pageSize) {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching next page", error);
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      // fetch all unread notifications
      const unreadNotifications = notificationList.filter(
        (notification) => !notification.is_read
      );
      console.log("unreadNotifications", unreadNotifications);

      if (unreadNotifications.length > 0) {
        unreadNotifications.forEach(async (notification) => {
          const notificationRef = ref(
            firebaseRDB,
            `history/generic/${transporterId}/${notification.key}`
          );
          await update(notificationRef, { is_read: true });
        });

        //  mark all notifications as read
        setNotificationsList((previous) =>
          previous.map((notification) => ({ ...notification, is_read: true }))
        );
      }
    } catch (error) {
      console.error("Error marking all notifications as read", error);
    }
  };

  if (error) {
    return (
      <Box>
        <Typography variant="h4" color="error">
          Something went wrong. Please try again later.
        </Typography>
      </Box>
    );
  }

  return (
    <Box pb={3}>
      <Stack
        position="fixed"
        width="100%"
        sx={{ background: "#EAEAEA", zIndex: 1000 }}
        py={2}
      >
        <Stack
          width="100%"
          m="auto"
          direction="row"
          maxWidth="lg"
          justifyContent="space-between"
          alignItems="center"
        >
          <Button
            sx={{
              color: "#333",
              fontWeight: 700,
              position: "absolute",
              left: "11rem",
            }}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIosRoundedIcon />
          </Button>

          <Typography
            fontWeight={700}
            color="#333"
            textAlign="center"
            flexGrow={1}
            variant="h5"
          >
            Notification
          </Typography>

          <Box
            sx={{
              position: "absolute",
              right: "11rem",
            }}
          >
            <Button
              sx={{ textTransform: "none" }}
              onClick={handleMarkAllAsRead}
              disabled={unreadCount === 0}
            >
              <MarkEmailReadOutlinedIcon
                sx={{
                  mx: "5px",
                }}
              />{" "}
              <span> Mark all as read</span>
            </Button>
          </Box>
        </Stack>
      </Stack>
      <Toolbar />
      {isLoading ? (
        <Stack
          m="auto"
          width="100%"
          maxWidth="lg"
          mt={5}
          mb={5}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          <GradientCirlularProgress />
        </Stack>
      ) : (
        <>
          <Stack m="auto" maxWidth="lg">
            {notificationList.length > 0 &&
              notificationList.map((each, idx) => (
                <Notification
                  data={each}
                  key={each.key || idx}
                  setNotificationsList={setNotificationsList}
                />
              ))}
          </Stack>
          {hasMore && !isLoading && notificationList.length > 0 && (
            <Stack direction="row" justifyContent="center" mt={5}>
              <Button
                variant="containedPrimary"
                sx={{ textTransform: "none" }}
                onClick={() => fetchNextPage()}
              >
                Load more...
              </Button>
            </Stack>
          )}
          {!hasMore && (
            <Typography textAlign="center" fontSize={16} color="#ADADAD" my={5}>
              You're all caught up !
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};
export default TransporterNotificationPage;

const Notification = ({ data, setNotificationsList }) => {
  const transporterId = useSelector((state) => state.transporterId.id);
  if (!transporterId) return null;

  const markNotificationAsRead = async (key) => {
    try {
      const notificationRef = ref(
        firebaseRDB,
        `history/generic/${transporterId}/${key}`
      );
      await update(notificationRef, { is_read: true });

      setNotificationsList((prev) =>
        prev.map((notification) =>
          notification.key === key
            ? { ...notification, is_read: true }
            : notification
        )
      );
    } catch (error) {
      console.error("Error marking notification as read", error);
    }
  };
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        gap={5}
        maxWidth="lg"
        px={5}
        py={2}
        sx={{
          // background: !data.is_read ? "#F5EFFF" : "",
          cursor: "pointer",
          "&:hover": {
            background: "#f7f5f5",
            cursor: "pointer",
            transition: "background 0.3s ease",
          },
        }}
        onClick={() => markNotificationAsRead(data.key)}
      >
        <Box
          sx={{
            width: "60%",
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <CircleNotificationsIcon
            sx={{
              color: !data.is_read ? "#574964" : "#b7afbd",
              fontSize: 30,
            }}
          />
          <Box>
            <Typography
              color={data.is_read ? "#918899" : "#574964"}
              fontWeight={700}
            >
              {data.title}
            </Typography>
            <Typography color="#ADADAD">{data.body}</Typography>
          </Box>
        </Box>
        <Typography
          color={data.is_read ? "#918899" : "#574964"}
          fontSize={12}
          fontWeight={700}
        >
          {moment(data.timestamp).format("Do MMMM YYYY hh:mm A")}
        </Typography>
      </Stack>
      <Divider />
    </>
  );
};
